import PropTypes from 'prop-types';
// @mui
import Box from '@mui/material/Box';
// routes
import { usePathname } from 'src/routes/hooks';
import Scrollbar from 'src/components/scrollbar';
//
import Footer from './footer';
import Header from './header';
import { HEADER } from '../config-layout';

// ----------------------------------------------------------------------

export default function MainLayout({ children }) {
  const pathname = usePathname();

  const isHome = pathname === '/';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100dvh', overflow: 'hidden' }}>
      <Header />

      <Box
        sx={{
          mt: { xs: `${HEADER.H_MOBILE}px`, md: `${HEADER.H_DESKTOP}px` },
          flex: '1 1 auto',
          minHeight: 0,
          overflow: 'hidden',
        }}
      >
        <Scrollbar
          sx={{
            height: 1,
            '& .simplebar-content': {
              minHeight: '100%',
            },
            '& .simplebar-content-wrapper': {
              height: '100%',
            },
          }}
        >
          <Box
            component="main"
            sx={{
              minHeight: '100%',
              display: 'flex',
              flexDirection: 'column',
              ...(isHome && {
                mt: { xs: `-${HEADER.H_MOBILE}px`, md: `-${HEADER.H_DESKTOP}px` },
              }),
            }}
          >
            {children}
            <Footer />
          </Box>
        </Scrollbar>
      </Box>
    </Box>
  );
}

MainLayout.propTypes = {
  children: PropTypes.node,
};
